import { _converse, api } from '@converse/headless';
import { html } from 'lit';
import { CustomElement } from './element.js';
import { __ } from 'i18n';

export class ConverseFooter extends CustomElement {
    render() {
        return html``;
    }
}

api.elements.define('converse-footer', ConverseFooter);
